import { useQuery } from "@tanstack/react-query";
import { getCartItemsWithOffline, getOfflineCart, normalizeStoreId } from "@/lib/offlineCart";
import { base44 } from "@/api/base44Client";

/**
 * סל הסניף — מקוון: מהשרת (ומסנכרן ללוקאל), לא מקוון: מ־localStorage.
 * אותו מפתח cache לכל האפליקציה — כרטיסי מוצר מציגים כמויות עדכניות.
 */
export function useCartItemsQuery(storeId, options = {}) {
  const { enabled = true, ...rest } = options;
  const sid = normalizeStoreId(storeId);
  return useQuery({
    queryKey: ["cartItems", sid],
    queryFn: () =>
      getCartItemsWithOffline(sid, () =>
        base44.entities.CartItem.list({ store_id: sid })
      ),
    enabled: !!sid && enabled,
    staleTime: 5 * 1000,
    refetchOnWindowFocus: true,
    // עד שה-queryFn מסתיים — מציגים את הסל מה-localStorage כדי שלא ייעלמו מספרים ברענון/מעבר דף
    placeholderData: (prev) =>
      prev !== undefined && prev !== null
        ? prev
        : sid
          ? getOfflineCart(sid)
          : [],
    ...rest,
  });
}
